import { render, staticRenderFns } from "./CampPrograms.vue?vue&type=template&id=23104560&scoped=true&"
import script from "./CampPrograms.vue?vue&type=script&lang=js&"
export * from "./CampPrograms.vue?vue&type=script&lang=js&"
import style0 from "./CampPrograms.vue?vue&type=style&index=0&id=23104560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23104560",
  null
  
)

export default component.exports